
import {queryevent} from '../../api/device'
import MescrollVue from 'mescroll.js/mescroll.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'Events',
components: {
MescrollVue 
},
directives: {
TransferDom
},
data () {
return {
showPopup: false,
timeVal: '2021-05-27',
mescroll: null, // mescroll实例对象
mescrollUp: { // 上拉加载的配置.
callback: this.upCallback,
isBoth: true,
dataList: [] 
},
cnt: 10,
page: 1,
eventData: [],
hashnext: true,
bgImg: [
{etype: 'add', imgUrl: 'background: url("../../../static/event/e_add.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'addmember', imgUrl: 'background: url("../../../static/event/e_add_member.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'delete', imgUrl: 'background: url("../../../static/event/e_del.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'update', imgUrl: 'background: url("../../../static/event/e_edit.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'd_add', imgUrl: 'background: url("../../../static/event/e_sub_add.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'setsub', imgUrl: 'background: url("../../../static/event/e_sub_set.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'shutdown', imgUrl: 'background: url("../../../static/event/e_shutdown.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'set', imgUrl: 'background: url("../../../static/event/e_set.png") no-repeat right;background-size: 100% 100%;'},
{etype: 'deletesub', imgUrl: 'background: url("../../../static/event/e_del.png") no-repeat right;background-size: 100% 100%;'},
{etype: '', imgUrl: 'background: url("../../../static/event/e_default.png") no-repeat right;background-size: 100% 100%;'}
]

}
},
methods: {

mescrollInit (mescroll) {
this.mescroll = mescroll 
},
upCallback (page, mescroll) {


this.page = page.num

let data = {
dids: [],
cnt: parseInt(this.cnt),
page: parseInt(this.page)
}
queryevent(data).then(res => {
let arr = res.data !== null ? res.data : []
if (this.page === 1) {
this.eventData = arr
} else {
this.eventData = this.eventData.concat(arr)
}
let vm = this
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(this.eventData.length)
}, 100)
})
}).catch(() => {
this.addWarn = true
this.warnText = '失败'
let vm = this
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(0)
}, 100)
})
})
},
getLineBg (type) {
let img = ''
for (let i = 0; i < this.bgImg.length; i++) {
if (type === this.bgImg[i].etype) {
img = this.bgImg[i].imgUrl
}
}
if (img === '') {
return this.bgImg[this.bgImg.length - 1].imgUrl
} else {
return img
}
},
getTimeTop (tm) {
let arr = tm.split(' ')
return arr[0]
},
getTimeBottom (tm) {
let arr = tm.split(' ')
return arr[1]
},
getColorShow (type) {
if (type === 'add') {

return {color: '#72c467'}
} else if (type === 'addmember') {

return {color: '#9663db'}
} else if (type === 'delete') {

return {color: '#ff5c5c'}
} else if (type === 'update') {

return {color: '#a8864a'}
} else if (type === 'd_add') {

return {color: '#f19ec2'}
} else if (type === 'setsub') {

return {color: '#ff8e43'}
} else if (type === 'shutdown') {

return {color: '#9e9e9e'}
} else if (type === 'set') {

return {color: '#1296db'}
} else if (type === 'deletesub') {

return {color: '#ff5c5c'}
} else {
return {color: '#333333'}
}
},
getEventType (type) {
if (type === 'add') {
return '添加设备'
} else if (type === 'addmember') {
return '添加成员'
} else if (type === 'delete') {
return '删除设备'
} else if (type === 'update') {
return '编辑设备'
} else if (type === 'd_add') {
return '添加子机'
} else if (type === 'setsub') {
return '设置子机'
} else if (type === 'shutdown') {
return '关机'
} else if (type === 'set') {
return '设置设备'
} else if (type === 'deletesub') {
return '删除子机'
} else {
return type
}
}
},
created () {
}
}



// WEBPACK FOOTER //
// ./src/components/event/Events.vue